import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {
  ParticipationFormCleanupComponent,
  ParticipationFormComponent,
  ParticipationFormListComponent
} from "./participation-form";
import {ConfirmationComponent} from "./confirmation";
import {ErrorComponent} from "./error/error.component";
import {AuthGuard, AppAdminGuard} from "./shared/guard";
import {StuckProgramsComponent} from "./stuck-programs";
import {
  CurrentUserResolve,
  ParticipationFormCleanupResolve,
  ParticipationFormCodeResolve,
  ParticipationFormResolve
} from "./shared/resolves";

const routes: Routes = [
  {path: '', component: HomeComponent, canActivate: [AuthGuard]},
  {
    path: 'participationForm',
    component: ParticipationFormComponent,
    canActivate: [AuthGuard],
    resolve: {
      currentUser: CurrentUserResolve,
      participationFormCode: ParticipationFormCodeResolve,
      participationForm: ParticipationFormResolve
    }
  },
  {
    path: 'participationForm/submissionCode/:submissionCode',
    component: ParticipationFormComponent,
    canActivate: [AuthGuard],
    resolve: {
      currentUser: CurrentUserResolve,
      participationFormCode: ParticipationFormCodeResolve,
      participationForm: ParticipationFormResolve
    }
  },
  {
    path: 'participationFormCleanup/submissionCode/:submissionCode',
    component: ParticipationFormCleanupComponent,
    canActivate: [AuthGuard],
    resolve: {
      currentUser: CurrentUserResolve,
      participationFormCode: ParticipationFormCodeResolve,
      participationForm: ParticipationFormCleanupResolve
    }
  },
  // TODO: add CurrentUserResolve to other routes
  {path: 'participationFormList', component: ParticipationFormListComponent, canActivate: [AuthGuard]},
  {path: 'stuck-programs', component: StuckProgramsComponent, canActivate: [AuthGuard, AppAdminGuard]},
  {path: 'confirmation', component: ConfirmationComponent, canActivate: [AuthGuard]},
  {path: 'error/:errorType', component: ErrorComponent},
  {path: '**', component: HomeComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class ClientRoutingModule {
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/app-routing.module.ts